__turbopack_context__.v({
  "checkoutBtn": "OrderSummary-module__IarBCW__checkoutBtn",
  "divider": "OrderSummary-module__IarBCW__divider",
  "label": "OrderSummary-module__IarBCW__label",
  "note": "OrderSummary-module__IarBCW__note",
  "row": "OrderSummary-module__IarBCW__row",
  "rows": "OrderSummary-module__IarBCW__rows",
  "summary": "OrderSummary-module__IarBCW__summary",
  "title": "OrderSummary-module__IarBCW__title",
  "total": "OrderSummary-module__IarBCW__total",
  "value": "OrderSummary-module__IarBCW__value",
});
